const isCommentWithTextAnnotation = (comment) => {
  return !!comment.annotation?.text;
};

export { isCommentWithTextAnnotation };
//# sourceMappingURL=annotationGuards.js.map
